import React from "react";
import Layout from "../Layout/Layout";

const ServiceBus = () => {
  return <Layout></Layout>;
};

export default ServiceBus;
